import { render, staticRenderFns } from "./CPDueDiligenceSourceAccordianItem.vue?vue&type=template&id=1b65af64&"
import script from "./CPDueDiligenceSourceAccordianItem.vue?vue&type=script&lang=ts&"
export * from "./CPDueDiligenceSourceAccordianItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports